var _defs, _path, _path2, _path3, _path4, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg3Daytrial2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1280 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: url(#linear-gradient2);\n      }\n\n      .st1 {\n        fill: #c9c9c9;\n      }\n\n      .st2 {\n        fill: url(#linear-gradient1);\n      }\n\n      .st3 {\n        fill: url(#linear-gradient);\n      }\n\n      .st4 {\n        fill: #4f7fff;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 125.1,
    y1: 1039,
    x2: 270.1,
    y2: 1039,
    gradientTransform: "translate(0 -982)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient1",
    x1: 1030.4,
    y1: 1039,
    x2: 1175.4,
    y2: 1039,
    gradientTransform: "translate(0 -982)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient2",
    x1: 648.5,
    y1: 1148.2,
    x2: 648.5,
    y2: 1014.8,
    gradientTransform: "translate(0 -982)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M256.4,55.3c-.1-.2-.2-.4-.4-.6-.1-.2-.3-.4-.4-.6,0,0-.1,0-.1-.2-.1,0-.2-.3-.3-.4,0,0-.1,0-.1-.2-.1,0-.2-.3-.3-.4,0,0-.1,0-.1-.2-.1,0-.2-.3-.3-.4h-.1c-.1-.3-.2-.4-.4-.6h-.1c-.1-.3-.3-.4-.4-.6,0,0,0,0-.1,0-.2-.2-.3-.3-.5-.5h0c-.2-.2-.4-.4-.6-.6-.3-.3-.6-.6-.9-.9h0c-1-.9-2.1-1.7-3.2-2.6h0c-.4-.3-.8-.5-1.2-.8h0c-1.2-.8-2.5-1.6-3.8-2.3h-.1c-.4-.2-.9-.5-1.3-.7h0c-.9-.5-1.9-.9-2.9-1.4h-.1c-.5-.2-1-.4-1.5-.6h-.2c-.5-.2-1-.4-1.5-.6h0c-1-.4-2.1-.8-3.2-1.2h-.2c-.5-.2-1-.3-1.6-.5h-.2c-.5-.2-1.1-.3-1.7-.5h0c-.6-.2-1.1-.3-1.7-.5h-.2c-.6,0-1.1-.3-1.7-.4h-.3c-.5,0-1.1-.3-1.7-.4h-.2c-1.2-.3-2.3-.5-3.5-.7h-.3c-.6,0-1.2-.2-1.7-.3h-.3c-.6,0-1.2-.2-1.8-.3h-.2c-.6,0-1.2-.2-1.8-.2h-.1c-.6,0-1.2-.2-1.8-.2h-.3c-.6,0-1.2,0-1.8-.2h-.3c-.6,0-1.2,0-1.9-.2h-.1c-.6,0-1.2,0-1.8,0h-.2c-.6,0-1.2,0-1.9,0h-4.6c-50.8,0-73.3,29.7-73.3,45.6l16.6-.3h128.4l-13.7-24.2h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1161.7,55.3c0-.2-.2-.4-.4-.6,0-.2-.3-.4-.4-.6,0,0,0,0,0-.2,0,0-.2-.3-.3-.4,0,0,0,0,0-.2,0,0-.2-.3-.3-.4,0,0,0,0,0-.2,0,0-.2-.3-.3-.4h0c0-.3-.2-.4-.4-.6h0c0-.3-.3-.4-.4-.6,0,0,0,0,0,0-.2-.2-.3-.3-.5-.5h0c-.2-.2-.4-.4-.6-.6-.3-.3-.6-.6-.9-.9h0c-1-.9-2.1-1.7-3.2-2.6h0c-.4-.3-.8-.5-1.2-.8h0c-1.2-.8-2.5-1.6-3.8-2.3h0c-.4-.2-.9-.5-1.3-.7h0c-.9-.5-1.9-.9-2.9-1.4h0c-.5-.2-1-.4-1.5-.6h-.2c-.5-.2-1-.4-1.5-.6h0c-1-.4-2.1-.8-3.2-1.2h-.2c-.5-.2-1-.3-1.6-.5h-.2c-.5-.2-1.1-.3-1.7-.5h0c-.6-.2-1.1-.3-1.7-.5h-.2c-.6,0-1.1-.3-1.7-.4h-.3c-.5,0-1.1-.3-1.7-.4h-.2c-1.2-.3-2.3-.5-3.5-.7h-.3c-.6,0-1.2-.2-1.7-.3h-.3c-.6,0-1.2-.2-1.8-.3h-.2c-.6,0-1.2-.2-1.8-.2h0c-.6,0-1.2-.2-1.8-.2h-.3c-.6,0-1.2,0-1.8-.2h-.3c-.6,0-1.2,0-1.9-.2h0c-.6,0-1.2,0-1.8,0h-.2c-.6,0-1.2,0-1.9,0h-4.6c-50.8,0-73.3,29.7-73.3,45.6l16.6-.3h128.4l-13.7-24.2h0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M701.9,33.4H204.2c-33.1,0-41.3-.6-21.1,4.6,13.7,3.6,24,9,29,15.4.2.2.3.4.4.6l62.8,85.5c17.4,23.8,67.4,43,111.6,43h517.2c44.2,0,94.1-19.3,111.6-43l62.8-85.5c0-.2.3-.4.4-.6,4.9-6.4,15.3-11.8,29-15.4,20.1-5.3,12-4.6-21.1-4.6h-384.9Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M773.2,33.4H178.3c29.9,0,55.3,7.6,63.6,18,.1.2.3.4.4.5l58.9,77.1c16.4,21.4,63.2,38.8,104.7,38.8h485.2c41.4,0,88.3-17.4,104.7-38.8,0,0,59.2-77.5,59.3-77.6,8.4-10.4,33.7-18,63.6-18h-345.5,0Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M440.9,99.6h-19.2v19.6h-11.9v-49.3h33v9.2h-21.1v11.3h19.2v9.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M468.5,92.9l-3.8-.3c-3.6,0-5.9,1.1-6.9,3.4v23.2h-11.4v-36.6h10.7l.4,4.7c1.9-3.6,4.6-5.4,8-5.4s2.3.1,3.2.4l-.2,10.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M490.3,119.9c-5.6,0-10.2-1.7-13.6-5-3.5-3.3-5.2-7.7-5.2-13.1v-.9c0-3.8.7-7.1,2.1-9.9,1.4-2.9,3.4-5.1,6.1-6.7,2.7-1.6,5.8-2.3,9.5-2.3s9.2,1.6,12.2,4.8,4.5,7.7,4.5,13.4v4.4h-22.7c.4,2.1,1.3,3.7,2.7,4.8,1.4,1.2,3.2,1.8,5.4,1.8,3.6,0,6.4-1.3,8.5-3.8l5.2,6.2c-1.4,2-3.4,3.5-6,4.7s-5.4,1.7-8.4,1.7h0ZM489,90.7c-3.3,0-5.3,2.2-6,6.6h11.5v-.9c0-1.8-.4-3.2-1.4-4.2-1-1-2.4-1.5-4.2-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M528.1,119.9c-5.6,0-10.2-1.7-13.7-5-3.5-3.3-5.2-7.7-5.2-13.1v-.9c0-3.8.7-7.1,2.1-9.9,1.4-2.9,3.4-5.1,6.1-6.7,2.7-1.6,5.8-2.3,9.5-2.3s9.2,1.6,12.2,4.8,4.5,7.7,4.5,13.4v4.4h-22.7c.4,2.1,1.3,3.7,2.7,4.8,1.4,1.2,3.2,1.8,5.3,1.8,3.6,0,6.4-1.3,8.5-3.8l5.2,6.2c-1.4,2-3.4,3.5-6,4.7s-5.4,1.7-8.4,1.7h0ZM526.8,90.7c-3.3,0-5.3,2.2-6,6.6h11.5v-.9c0-1.8-.4-3.2-1.4-4.2-1-1-2.4-1.5-4.2-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M575.6,89.8h5.4c4.3,0,6.4-2.1,6.4-6.3s-.5-2.9-1.5-4c-1-1-2.5-1.5-4.3-1.5s-2.8.4-3.9,1.3c-1.1.9-1.7,2-1.7,3.3h-11.4c0-2.6.7-4.9,2.2-6.9,1.4-2,3.5-3.6,6-4.8s5.4-1.7,8.5-1.7c5.5,0,9.8,1.2,12.9,3.8,3.1,2.5,4.7,5.9,4.7,10.3s-.7,4.1-2,6c-1.3,1.9-3.2,3.4-5.7,4.6,2.6.9,4.7,2.4,6.2,4.3s2.2,4.3,2.2,7.2c0,4.4-1.7,7.9-5.1,10.6s-7.8,4-13.3,4-6.2-.6-9-1.8c-2.8-1.2-4.9-2.9-6.3-5.1-1.4-2.2-2.1-4.7-2.1-7.4h11.5c0,1.5.6,2.8,1.8,3.9,1.2,1.1,2.7,1.7,4.5,1.7s3.6-.6,4.8-1.7,1.8-2.5,1.8-4.3c0-2.5-.6-4.2-1.9-5.3s-3-1.6-5.2-1.6h-5.5v-8.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M629.3,119.2v-49.3h15.9c4.4,0,8.3,1,11.8,3,3.5,2,6.2,4.8,8.1,8.4s2.9,7.6,3,12.1v2.3c0,4.5-1,8.6-2.9,12.1s-4.6,6.4-8.1,8.4c-3.5,2-7.3,3-11.6,3.1h-16.2,0ZM641.2,79.1v31h4.1c3.4,0,6-1.2,7.8-3.6s2.7-6,2.7-10.8v-2.1c0-4.8-.9-8.3-2.7-10.8-1.8-2.4-4.5-3.6-8-3.6h-4,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M694.3,119.2c-.4-.8-.8-1.8-1.1-3.3-2.1,2.6-5,4-8.8,4s-6.4-1-8.8-3.1c-2.4-2.1-3.6-4.7-3.6-7.9s1.5-7,4.4-9c2.9-2,7.2-3.1,12.8-3.1h3.5v-1.9c0-3.4-1.5-5.1-4.4-5.1s-4.1,1.3-4.1,4h-11.4c0-3.5,1.5-6.4,4.5-8.6s6.9-3.3,11.5-3.3,8.4,1.1,11.1,3.4,4.1,5.4,4.2,9.4v16.2c0,3.4.6,5.9,1.6,7.7v.6h-11.4ZM687.1,111.8c1.4,0,2.6-.3,3.5-.9s1.6-1.3,2-2.1v-5.9h-3.3c-4,0-6,1.8-6,5.3s.3,1.9,1,2.5,1.6,1,2.7,1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M725.1,103.3l6.1-20.7h12.2l-14.9,42.8-.6,1.6c-2.1,4.7-5.9,7.1-11.2,7.1s-3.1-.2-4.7-.7v-8.1h1.5c1.6,0,2.8-.2,3.7-.7s1.5-1.3,1.9-2.5l.9-2.4-12.7-37h12.2l5.8,20.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M800.8,79.1h-14.8v40.1h-11.9v-40.1h-14.5v-9.2h41.2s0,9.2,0,9.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M825.3,92.9l-3.8-.3c-3.6,0-5.9,1.1-6.9,3.4v23.2h-11.4v-36.6h10.7l.4,4.7c1.9-3.6,4.6-5.4,8-5.4s2.3.1,3.2.4l-.2,10.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M829.3,73.2c0-1.6.6-3,1.8-4s2.7-1.6,4.6-1.6,3.4.5,4.6,1.6,1.8,2.4,1.8,4-.6,3-1.8,4-2.7,1.6-4.6,1.6-3.4-.5-4.6-1.6-1.8-2.4-1.8-4ZM841.4,119.2h-11.4v-36.6h11.4v36.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M869.1,119.2c-.4-.8-.8-1.8-1.1-3.3-2.1,2.6-5,4-8.8,4s-6.4-1-8.8-3.1c-2.4-2.1-3.6-4.7-3.6-7.9s1.5-7,4.4-9c2.9-2,7.2-3.1,12.8-3.1h3.5v-1.9c0-3.4-1.5-5.1-4.4-5.1s-4.1,1.3-4.1,4h-11.4c0-3.5,1.5-6.4,4.5-8.6s6.9-3.3,11.5-3.3,8.4,1.1,11.1,3.4,4.1,5.4,4.2,9.4v16.2c0,3.4.6,5.9,1.6,7.7v.6h-11.4ZM861.9,111.8c1.4,0,2.6-.3,3.5-.9s1.6-1.3,2-2.1v-5.9h-3.3c-4,0-6,1.8-6,5.3s.3,1.9,1,2.5,1.6,1,2.7,1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M897.3,119.2h-11.4v-52h11.4v52Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 607.5,
    y: 91.1,
    width: 14,
    height: 6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3Daytrial2);
export default __webpack_public_path__ + "static/media/3daytrial (2).a785b0b2a912aad7840f00d2ae6d282e.svg";
export { ForwardRef as ReactComponent };